import { api } from '@api'
import { FormTypeSupplier, Ticket } from '@types'

interface GetTicketsResponse {
  tickets: Ticket[]
}

const createTicket = async (payload: FormTypeSupplier) => {
  const response = await api.post<GetTicketsResponse>('/tickets', { ticket: payload })

  return response.data
}

export const TicketsApi = { createTicket }
